import { useRef } from 'react';
import { useSectionMetrics } from '../motion/scroll';
import { range } from '../motion/tokens';
import { useLocale } from '../i18n/locale';
import { sectionId } from '../content/site';
import { HOME } from './content';
import { Lines } from './Lines';

/**
 * Total economics without numbers: what a buyer sees first, then the components that make up the
 * cost of the decision, assembled one by one. Illustrative components, never figures.
 */
export function Economics() {
  const { locale } = useLocale(); const copy = HOME[locale].economics;
  const ref = useRef<HTMLElement>(null);
  const real = useRef<HTMLOListElement>(null);
  useSectionMetrics(ref, ({ track, visible }) => {
    if (!visible || !real.current) return;
    const shown = range(track, 0.18, 0.78) * copy.is.parts.length;
    real.current.querySelectorAll<HTMLElement>('li').forEach((item, index) => { const t = Math.min(1, Math.max(0, shown - index)); item.style.setProperty('--in', t.toFixed(3)); });
  });
  return (
    <section ref={ref} id={sectionId('economics', locale)} className="cost" data-tone="light" aria-labelledby="economics-title">
      <div className="cost__sticky">
        <div className="cost__inner wrap">
          <header className="section-head">
            <h2 id="economics-title" className="section-title"><Lines lines={copy.title} /></h2>
            <p className="section-body">{copy.body}</p>
          </header>
          <div className="cost__compare">
            <div className="cost__row cost__row--seems">
              <p className="cost__label">{copy.seems.label}</p>
              <ol className="cost__bar" role="list">{copy.seems.parts.map(part => <li key={part}><span>{part}</span></li>)}</ol>
            </div>
            <div className="cost__row cost__row--is">
              <p className="cost__label">{copy.is.label}</p>
              <ol ref={real} className="cost__bar" role="list">{copy.is.parts.map(part => <li key={part}><span>{part}</span></li>)}</ol>
            </div>
            <p className="cost__note"><Lines lines={copy.note} /></p>
          </div>
        </div>
      </div>
    </section>
  );
}
